import { usePostHog } from '@/lib/posthog'

// @ts-ignore
const toast = useToast()
const { posthog } = usePostHog()

function handleErrorCallback(
  defaultErrorMessage: string = 'Please try again later.',
  errorTitle: string = 'Something went wrong...',
): (error: unknown) => void {
  return (error: unknown) => {
    toast.add({
      title: errorTitle,
      description:
        error instanceof Error ? error.message : (error?.toString() ?? defaultErrorMessage),
      icon: 'i-lucide-octagon-x',
      color: 'error',
    })
    console.error(error)
    posthog.captureException(error)
  }
}

function handleError(error: unknown, defaultErrorMessage?: string, errorTitle?: string): void {
  handleErrorCallback(defaultErrorMessage, errorTitle)(error)
}

export { handleError, handleErrorCallback }
